<template>
  <div>
    <el-row style="height: 60px; margin-top: 20px">
      <el-col >
        <p><span>1、登录A店铺，点击“生成绑定码”按钮，复制生成的店铺绑定码</span></p>
        <p><span>2、登录B店铺，输入A店铺生成的绑定码，点击“绑定店铺”按钮，实现A、B店铺双向绑定</span></p>
        <p><el-button type="primary" @click="createCode">生成绑定码</el-button>
          <span style="font-size: 14px;font-weight: bold">当前绑定码：{{code}} (15分钟内有效)</span></p>
        <p><span>店铺绑定</span></p>
        <p><el-input type="text" v-model="bindCode" style="width: 400px" placeholder="请输入其他店铺生成的绑定码"></el-input>
          <el-button type="danger" @click="shopBind">绑定店铺</el-button> </p>
        <p>当前绑定店铺</p>
        <el-table border style="font-size: 12px; width: 570px" :data="bindUsers" :header-cell-style="{background:'#F2F6FC',color:'#000'}">
          <el-table-column width="60px" label="ID"
                            type="index"
                            :index="indexMethod">
          </el-table-column>
          <el-table-column  prop="bindNick" label="绑定旺旺" width="400px"></el-table-column>
          <el-table-column  label="" width="100px">
            <template slot-scope="scope">
              <el-button type="text" size="mini"  style="display: inline" @click="confirmDeleteBind(scope.$index, scope.row)">解除绑定</el-button>
            </template>
          </el-table-column>

        </el-table>
      </el-col>
    </el-row>

  </div>
</template>

<script>
    import storage from "../api/storage";
    import $api from "../api/axios";

    export default {
      name: "Bind",
      data(){
          return{
            code:'空，请点击"生成绑定码"生成',
            bindCode:'',
            bindUsers:[],
          }
      },
      methods:{
        indexMethod(index)
        {
          return index + 1;
        },
        createCode:function () {
          let param = {
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
          }
          $api.post("/getShopCode", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.code = dataResult.data;
            }else{
              this.$message.error(dataResult.message);
            }
          })

        },
        shopBind:function () {
          if(this.bindCode == ""){
            this.$message.error("请输入其他店铺生成的绑定码。")
            return;
          }
          if(this.bindCode.length<32){
            this.$message.error("绑定码长度不正确，请重新复制其他店铺中生成的绑定码。")
            return;
          }
          let param = {
            nick: storage.get("nick"),
            subNick:storage.get("subnick"),
            code: this.bindCode
          }
          $api.post("/addShop", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok"){
              this.getShopBind();
            }else{
              this.$message.error(dataResult.message);
            }
          })

        },
        getShopBind: function(){
          console.log("bind");
          let param={
            nick: storage.get("nick"),
            subNick:storage.get("subnick")
          }
          $api.post("/getShop", param,response=> {
            console.log(response.data)
            let dataResult = response.data;
            if (dataResult.state == "1" && dataResult.message == "ok") {
              this.bindUsers = dataResult.data
              console.log(this.bindUsers);
            } else {
              this.$message.error(dataResult.message);
            }
          })
        },
        confirmDeleteBind:function(index, row){
          this.$confirm("确定要删除绑定的店铺吗？", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success'
          }).then(() => {
            this.deleteBind(index, row);
          })
        },
        deleteBind:function (index, row) {
          let param ={
            nick:storage.get("nick"),
            subNick: storage.get("subnick"),
            changeNick: row.bindNick
          };
          $api.post("/deleteBind", param, response => {
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              this.getShopBind();
            }else {
              this.$message.error(dataResult);
            }
          })
        },

      },
      mounted() {
        this.getShopBind();
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/Bind.vue